const getTypes = storeName => ({
    SAVE_DISTRICTS_BY_CITY: `${storeName}.SAVE_DISTRICTS_BY_CITY`,
    SET_CITY_REFERRED_TO_CURRENT_DISTRICTS: `${storeName}.SET_CITY_REFERRED_TO_CURRENT_DISTRICTS`,
    SET_FAKE_VALIDATION: `${storeName}.SET_FAKE_VALIDATION`,
    SAVE_NEIGHBORHOODS_BY_DISTRICT: `${storeName}.SAVE_NEIGHBORHOODS_BY_DISTRICT`,
    SET_DISTRICT_REFERRED_TO_CURRENT_NEIGHBORHOODS: `${storeName}.SET_DISTRICT_REFERRED_TO_CURRENT_NEIGHBORHOODS`,
});

export default getTypes;
